const chunkManager = {
    registry: {
        /* LAYOUTS */
        header: () => import(/* webpackChunkName: "header" */ '../layouts/header.js'),

        /* REGIONS */
        headerNavigation: () => import(/* webpackChunkName: "header-navigation" */ '../regions/header-navigation.js'),
        headerSearch: () => import(/* webpackChunkName: "header-search" */ '../regions/header-search.js'),
        headerFlashinfo: () => import(/* webpackChunkName: "header-flashinfo" */ '../regions/header-flashinfo.js'),
        headerBurger: () => import(/* webpackChunkName: "header-burger" */ '../regions/header-burger.js'),

        /* MODULES */
        video: () => import(/* webpackChunkName: "video" */ '../modules/video.js'),
        hompageHeader: () => import(/* webpackChunkName: "homepage-header" */ '../modules/homepage-header.js'),
        featuredExpos: () => import(/* webpackChunkName: "featured-expos" */ '../modules/featured-expos.js'),
        collections: () => import(/* webpackChunkName: "collections" */ '../modules/collections.js'),
        ongoingExpos: () => import(/* webpackChunkName: "ongoing-expos" */ '../modules/ongoing-expos.js'),
        quote: () => import(/* webpackChunkName: "quote" */ '../modules/quote.js'),
        footerUp: () => import(/* webpackChunkName: "footer-up" */ '../modules/footer-up.js'),
        carousel: () => import(/* webpackChunkName: "carousel" */ '../modules/carousel.js'),

        /* PAGES */
        archiveEvenement: () => import(/* webpackChunkName: "archive-evenement" */ '../pages/archive-evenement.js'),
        archiveDiscographie: () => import(/* webpackChunkName: "archive-discographie" */ '../pages/archive-discographie.js'),
        archiveInterpretes: () => import(/* webpackChunkName: "archive-interprete" */ '../pages/archive-interprete.js'),

        /* CORE */
        scrollEffects: () => import(/* webpackChunkName: "scroll-effects" */ '../ui/scroll-effects.js'),

        /* COMPONENTS */
        backtop: () => import(/* webpackChunkName: "backtop" */ '../components/backtop.js'),
        search: () => import(/* webpackChunkName: "search" */ '../components/search.js'),
        consentGate: () => import(/* webpackChunkName: "consent-gate" */ '../components/consent-gate.js'),

        /* PARTIALS */
        accordion: () => import(/* webpackChunkName: "accordion" */ '../partials/accordion.js'),
        formGravity: () => import(/* webpackChunkName: "form-gravity" */ '../partials/form-gravity.js'),

        /* VENDORS */
        accessconfig: () => import(/* webpackChunkName: "header-accessibility" */ '../vendors/accessconfig.js'),
        fancybox: () => import(/* webpackChunkName: "fancybox" */ '../vendors/fancybox.js'),
    },

    loadedChunks: new Map(),

	// Permet à un thème enfant d'ajouter ou de surcharger des entrées avant init()
	register(entries) {
		Object.assign(this.registry, entries);
	},

	init() {
		console.groupCollapsed('[chunks.js]');
		const chunksToLoad = this.collectRequestedChunks();
		chunksToLoad.forEach((chunkName) => {
			this.loadChunk(chunkName);
		});
		console.groupEnd();
	},

	async loadChunk(name) {
		// Gérer plusieurs chunks séparés par des espaces
		const chunkNames = name
			.split(/[\s,]+/)
			.map((chunkName) => chunkName.trim())
			.filter(Boolean);

		if (chunkNames.length === 0) return null;

		// Si un seul chunk, utiliser la logique existante
		if (chunkNames.length === 1) {
			return this.loadSingleChunk(chunkNames[0]);
		}

		// Si plusieurs chunks, les charger en parallèle
		console.log(`[chunks] Chargement de plusieurs chunks: "${chunkNames.join(', ')}"`);
		const promises = chunkNames.map((chunkName) => this.loadSingleChunk(chunkName));
		const results = await Promise.all(promises);

		// Retourner le dernier chunk chargé (pour compatibilité)
		return results[results.length - 1];
	},

	async loadSingleChunk(name) {
		if (!this.registry?.[name]) {
			console.warn(`[chunks] Chunk inconnu: "${name}"`);
			return null;
		}

		if (!this.loadedChunks.has(name)) {
			console.log(`[chunks] Chargement du chunk "${name}"`);
			const promise = this.registry[name]()
				.then((chunk) => chunk?.default ?? chunk)
				.then((chunk) => {
					if (chunk && typeof chunk.init === 'function') {
						chunk.init();
					}
					console.log(`[chunks] Chunk "${name}" initialisé`);
					return chunk;
				})
				.catch((error) => {
					console.error(`[chunks] Échec du chargement du chunk "${name}"`, error);
					return null;
				});

			this.loadedChunks.set(name, promise);
		}

		return this.loadedChunks.get(name);
	},

	collectRequestedChunks() {
		const requested = new Set();

		document.querySelectorAll('[data-chunk]').forEach((element) => {
			const value = element.getAttribute('data-chunk');
			console.log(`[chunks] Élément "${element.tagName}" demande le chunk(s): "${value}"`);
			if (!value) return;

			if (
				element.hasAttribute('data-chunk-lazy') ||
				element.hasAttribute('data-chunk-preload') ||
				element.hasAttribute('data-fancybox')
			) {
				return;
			}

			value
				.split(/[\s,]+/)
				.map((chunkName) => chunkName.trim())
				.filter(Boolean)
				.forEach((chunkName) => requested.add(chunkName));
		});

		return requested;
	},
};

export const loadChunk = (name) => chunkManager.loadChunk(name);

export default chunkManager;
